import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  mobileStyles: {
    "& .MuiTypography-h6": {
      fontSize: '17px'
    },
    "& .MuiPaper-root": {
      overflow: "visible",
      width: "80%",
      height: "auto",
      position: "relative",
    },
    "& .MuiDialogTitle-root": {
      textAlign: "center",
      color: "#33445f",
    },
    "& .MuiFab-root": {
      color: "#FF6B0B",
      position: "absolute",
      top: "-12px",
      right: "-15px",
      border: "1px solid #FF6B0B",
      width: "36px",
      height: "36px",
      background: "#FEFEFE",
      display:'none'
    },
    "& .MuiButton-root" : {
      background:'#FF6B0B',
      fontSize:'16px',
      color: '#ffff',
      padding:'6px 26px'
    },
    "& .MuiDialogActions-root" : {
      justifyContent: 'center'
    }
  },
  defaultModal: {
    "& .MuiTypography-h6": {
      fontSize: '20px'
    },
    "& .MuiPaper-root": {
      overflow: "visible",
      width: "32%",
      height: "auto",
      position: "relative",
      padding: '2%'
    },
    " & .MuiDialogContent-root": {
      overflow: "hidden",
    },
    "& .MuiDialogTitle-root": {
      textAlign: "center",
      color: "#33445f",
    },
    "& .MuiFab-root": {
      color: "#FF6B0B",
      position: "absolute",
      top: "-12px",
      right: "-15px",
      border: "1px solid #FF6B0B",
      width: "36px",
      height: "36px",
      background: "#FEFEFE",
      display: 'none'
    },
    "& .MuiIconButton-root": {
      color: "#FF6B0B",
      width: "36px",
      height: "36px",
      background: "#FEFEFE",
      borderRadius: "4px",
    },
    "& .MuiButton-root" : {
      background:'#FF6B0B',
      fontSize:'16px',
      color: '#ffff',
      padding:'10px 30px'
    },
    "& .MuiDialogActions-root" : {
      justifyContent: 'center'
    }
  }
}));



// WEBPACK FOOTER //
// ./src/controllers/gnp-modal/component-styles.js